var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" test "),_c('v-btn',{on:{"click":_vm.chargeCustomer}},[_vm._v("test")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }